import React from 'react';
import ContactInfo from '../Components/ContactInfo';
import _Services from '../Components/Services';

function Services() {
    return (
        <>
        <_Services/>
        <ContactInfo/>
        {/* 
         <!--====== SERVICE2 SECTION START ======-->

        <!--====== CONTACT INFO SECTION START ======-->

        <!--========= JS Here =========-->
        
        */}
        </>
    );
}

export default Services;